import { TUserRole } from '../../types/currentUser';

export enum EUserRoleActionTypes {
  SetUserRole = 'userRole/set',
}

export interface ISetUserRoleAction {
  type: EUserRoleActionTypes.SetUserRole;
  payload: TUserRole;
}

export const setUserRole = (userRole: TUserRole): ISetUserRoleAction => ({
  type: EUserRoleActionTypes.SetUserRole,
  payload: userRole,
});

export type TUserRoleActions = ISetUserRoleAction;
